import type { RefObject } from 'react'
import React, { useEffect, useState } from 'react'

export function useResizeObserver(): [RefObject<HTMLDivElement>, number] {
  const [width, setWidth] = useState<number>(0)
  // we need to use `React.useRef` otherwise we cannot mock it tests
  const ref = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    const updateWidth = (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        if (ref.current && entry.target === ref.current) {
          setWidth(entry.contentRect.width)
        }
      }
    }

    const resizeObserver = new ResizeObserver(updateWidth)

    if (ref.current) {
      resizeObserver.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        resizeObserver.unobserve(ref.current)
      }
    }
  }, [])

  return [ref, width]
}
